module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("A K"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ING")])]), _vm._v(" family wedding…but it wasn’t hers and Tommy’s as she’d dreamed of so many times.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even as Samantha Connelly told herself it was a terrible thing to envy people she really liked and wished well, the feeling would not go away. In another hour or so, Miranda Wade would be exchanging marriage vows with Nathan King, their love for each other would be shining out of them, and Sam just knew she was going to be sick with envy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The worst of it was, there was no way to avoid seeing this wedding through at close quarters. As the one and only bridesmaid, she couldn’t wander off and lose herself amongst the crowd of guests. She had to be on hand, performing her duties as helper of the bride, and the whole time she would have to suffer being linked to Tommy King, Nathan’s brother and best man, wishing she was the bride and he was the groom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tommy…who still treated her like a kid sister to be petted and teased and taken for granted as a background part of his life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tommy…who’d probably be eyeing off every attractive woman at the wedding. But not her. Never her. And she’d end up saying something mean and bitchy to him out of sheer frustration, when what she truly wanted…")])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A knock on her door and Elizabeth King’s call, “Are you dressed, Sam? May I come in?” forced a swift change of expression from gloom to the expected pleasurable excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. I’m ready,” she replied, preparing herself for the all too discerning scrutiny of Tommy’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elizabeth stepped into the room that had been allotted to Sam years ago when she’d first come to work on the great cattle station of King’s Eden. Those days were long gone, but the sense of being at home here with Elizabeth filling the role of her stand-in mother still lingered. Comfortable familiarity and affection poured into both their smiles as they viewed each other in their wedding finery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You look wonderful, Elizabeth.” Sam spoke first, admiring the graceful silvery grey tunic and long skirt the older woman wore with distinction. The outfit was made of a soft, fine knit and trimmed with satin ribbon, and it was set off with the beautiful pearls she always wore. Even in her sixties Elizabeth King was still a very handsome woman, tall, white-haired, with the brilliant dark brown eyes Tommy had inherited.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So do you, Sam,” came the warm reply. “More beautiful than I’ve ever seen you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The compliment stirred a self-deprecating laugh. “The miracle of cosmetics. I hardly recognise myself. No freckles on show, my hair done up…” She turned to her reflection in the dressing-table mirror. “It’s like looking at a stranger.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("“That’s because you’ve never bothered making ")]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("the most of yourself,” Elizabeth commented dryly, walking over to stand behind her. Their eyes met in the mirror. “Sometimes it does a woman’s heart good to see herself at her best.”")])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Would Tommy see her as sexy and beautiful today? Sam wryly wondered. The lilac satin strapless gown certainly emphasised every curve of her figure. Not that she was lushly curved like Miranda. All the same, she was generally satisfied with the shape of her body and it was in proportion to her average height. The slim-line gown gave her an elegance she’d never attached to herself before, but sexy?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, at least I can’t be seen as a tomboy in this dress,” she commented, trying to ease the tight, hopeless feeling in her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You shouldn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("feel")]), _vm._v(" like one, either. Why not let yourself enjoy being a woman today? Don’t fight it. Just let this image you see in the mirror take over and be you,” Elizabeth quietly advised.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But it’s not really me. All this clever make-up…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Brings out the lovely blue of your eyes and highlights the fine bone structure of your face.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve never worn my hair like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sam tentatively touched the copper curls that had been raked back and pinned into a crown around the top of her head. Usually they dangled in a mop around her face, hiding her ears and her feelings, when she needed to hide them. This style left her without any protection.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("And she wasn’t at all sure of the wisdom of wearing the artificial lilac rose, pushed into one side of ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("the high nest of curls which Sam suspected would spring out and escape the pins sooner or later. However, this look was what Miranda wanted and she was the bride, so Sam had kept her mouth firmly shut while the hairdresser had done what Miranda had directed.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can’t you see how elegant it is?” Elizabeth appealed. “Just for once your face isn’t dwarfed by a riot of curls around it, and having your hair up bares the line of your neck and shoulders, showing off your milky skin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It made Sam feel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" bare, especially with the strapless dress, and she simply wasn’t used to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("elegant,")]), _vm._v(" which made her very nervous about having to carry it off. What if the rose fell out and her curls tumbled down? She could just see Tommy laughing at her as the elegant sham came apart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s just not me,” she repeated with an apprehensive sigh, thinking she was bound to forget the eye make-up and smudge it. Probably end up looking like a clown. Especially if she wept at the wedding ceremony and the mascara ran.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" you.” Elizabeth grasped her arms and looked, for a moment, as though she wanted to shake her, but she took a deep breath and contented herself by forcing Sam to hold still and keep looking in the mirror. “It’s the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" that might have been if you hadn’t been brought up on an Outback cattle station, always competing with the men, trying to prove you were as good, if not better, at everything they did, from breaking in horses to mustering by helicopter.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("A flush of denial scorched Sam’s cheeks. “I ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("wasn’t trying to be a man, Elizabeth. I just wanted respect from them.”")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, maybe you were so busy winning respect, you forgot men want that, too.” She sighed and her mouth curled into an ironic smile. “You were always hell-bent on proving you could beat them at their own game, even to breaking in that maverick stallion Tommy wanted to break in for himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sam frowned at the criticism which had never been levelled at her before. Her recollection of that same incident was different. She’d been eighteen at the time and desperate to win Tommy’s admiration and turn their relationship into something warmer, more personal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He was going the wrong way about it,” she said in mitigation of her actions, too sensitive about her unrequited feelings to lay out her motives. “That horse didn’t want to be dominated.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So you showed him,” came the pointed reply.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her flush deepened painfully as she remembered Tommy’s furious reaction to her triumphant pleasure in presenting the gentled horse. “I wasn’t trying to beat him. I meant it as a gift,” she muttered defensively. “I thought he’d be pleased.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("Elizabeth shook her head over the lack of understanding, and with sympathy in her eyes, explained, “Tommy has been competing against Nathan all his life. It’s why he broke away from Nathan’s authority over the cattle station and built up his air charter business. To become his own man. Which he demanded Nathan acknowledge and respect when he ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("asked for a portion of King’s Eden to be turned into a wilderness resort for tourists.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She paused, then shot home the truth as she saw it. “Tommy doesn’t want a woman competing with him, Sam. He wants a woman who will partner him. A woman…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sam bit her lip and swallowed the fiery retort that had leapt to her tongue, blitzing Elizabeth’s view of what her second son wanted…. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tommy’s taste in women ran to nothing more than male ego-pumpers, not possible partners, and if he’d wanted a real partner in all his enterprises, a helpmate, a soul mate, there was none more capable and willing than she was and he was a fool for not seeing it.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blistering thoughts left an awkward silence after Elizabeth had stopped saying whatever she had said. Sam didn’t know if some comment was expected of her. She had none to make anyway. None Elizabeth would want to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a sigh, Elizabeth released her hold and fos-sicked in the silver bag hanging from her wrist. “I’ve brought you Nathan’s gift for being Miranda’s bridesmaid.” She lifted out a purple velvet box and set it on the dressing-table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sam wrenched her mind out of its dark brooding and stared down at the box. No one had ever given her jewellery. A new horse, a new saddle, a motorbike, helicopter-flying lessons…all the birthday presents she’d ever requested had been aimed at what she wanted to do with her life, not at embellishing her femininity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wasn’t expecting anything,” she half protested.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s traditional for the groom to thank the bridesmaid this way,” Elizabeth explained.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, never having been a bridesmaid…” She opened the box somewhat nervously, hoping Nathan hadn’t spent a lot of money on her, and gasped at the beautiful pearl pendant on a fine gold chain, accompanied by matching pearl earrings. “I can’t accept this!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nonsense! It’s the perfect complement for your dress.” Elizabeth removed the delicate necklace and hung it around Sam’s throat, proceeding to fasten it there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My ears aren’t pierced.” She’d tried it once in an attempt to compete with the procession of Barbie doll women Tommy favoured, but it had been a miserable failure, the holes getting badly infected, despite her taking every care.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They’re clip-ons,” Elizabeth informed her. “Made especially for you. Put them on, Sam. I want to see the complete effect.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Realising argument would be futile since Elizabeth had probably chosen the set herself, Sam fumbled them onto her almost nonexistent earlobes and tried to shut her mind to what such lustrous pearls would cost a normal buyer. To the King family it wouldn’t be so much, with their ownership of the pearl farm in Broome, not to mention mining interests in gold and diamonds, as well as their legendary stake in the cattle industry and Tommy’s enterprises.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Their wealth had never bothered her, never really touched her…until now. She’d always earned her keep at King’s Eden, working on the cattle station ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("and in more recent years, at Tommy’s resort. Still, if this was Nathan’s idea of a gift for her, a memento of his wedding and the part she played in it, there really was no other option but to accept it.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Perfect!” Elizabeth declared, her dark eyes twinkling intense satisfaction as Sam lowered her hands, revealing this fabulous last polish to her appearance. “You have such dainty ears. You should show them off more.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pixie ears,” Sam replied with a grimace, remembering the teasing she’d suffered at school. “These earrings will probably kill me by the end of the day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah, but they set off your face and neck beautifully. Leave them on. You look absolutely perfect now. Luminous and alluring.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She would never have attached such words to herself, yet the pearls did make a difference, adding a glow that seemed to make the lilac satin and even her copper hair more lustrous.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The beautician should be finished with Miranda in another ten minutes,” Elizabeth said, checking her watch. “Better go along to her room then. She’ll need help with her dress and veil. I’m just going to check on Nathan and Tommy. Make sure they’re on schedule.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was at the door before Sam found wits enough to say, “Thank you for…for everything, Elizabeth.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes locked onto Sam’s once more. “Promise me…” She hesitated, grimaced. “I guess it’s too much to ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please…ask.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("A heavy sigh. Her eyes softened, pleading for un")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("derstanding. “Don’t take this unkindly. I mean it for the best, believe me. I don’t think anyone enjoys the bickering that goes on between you and Tommy. He baits, you bite. You bait, he bites. Do you think you could let all that ride today? Nathan’s wedding day? I know it’s a habit you’ve got into but it’s childish and I wish…”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head, pained at having to make the apologetic request. Then with an earnest look and an appealing smile, she added, “The elegant woman I see before me doesn’t have to compete with anyone. Carry that thought with you, Sam. Win respect…for being a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Childish")]), _vm._v("…The accusation burned through Sam for several minutes after Elizabeth had left. The worst of it was having to acknowledge the tit-for-tat game had started in their teens, probably a childish bid on her part to gain and hold Tommy’s attention. But it had been fun in those days. It hadn’t developed bite until after the horse-breaking incident, his furious resentment of her action stirring resentment in her. And sickening disappointment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Since then…ten years of bickering, with the pattern of behaviour between them so deeply set, Sam didn’t know if she could stop it. In some perverse way, it had felt like a bond of intimacy between them, a running commentary on each other’s lives that none of his simpering women could share because it went so far back and held so much familiarity…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she didn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("want")]), _vm._v(" to be his kid sister.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("With despairing anguish clutching her heart, Sam ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("turned to look again at the woman in the mirror. Not one trace of a childish spitfire in that woman. Elegant, luminous, alluring…could she be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v(" today? Would Tommy treat her differently, see in her a woman he wanted in his bed, making love instead of making war?")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sam took a deep breath and made a fierce resolution.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Today, no matter how hard it might be to keep it up, she would be that woman, inside and out. She would hold that image in her mind and live up to it. Not because Elizabeth had asked her to. Not because it was Nathan’s wedding. Because suddenly, she saw it as her only hope to change the ground between her and Tommy, and if it didn’t work…perhaps nothing ever would.")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec2bf76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459206717_ch01.vue
// module id = 69
// module chunks = 0